import { render, staticRenderFns } from "./overviewappusers.vue?vue&type=template&id=353f4ffa&scoped=true"
import script from "./overviewappusers.vue?vue&type=script&lang=js"
export * from "./overviewappusers.vue?vue&type=script&lang=js"
import style0 from "./overviewappusers.vue?vue&type=style&index=0&id=353f4ffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353f4ffa",
  null
  
)

export default component.exports